import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isMobile } from 'react-device-detect';
import ProviderManager from '../../../provider/providerManager';
import { getBenefit } from '../PopupBenefitBlock/BenefitSlice';
import { getMyInvoices } from '../PersonalAreaInvoicesBlock/invoiceComponentBlockSlice';
import { getCustomerCoreProducts } from '../CoreProductActionsBlock/CoreProductActionsSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { WorkOrderStatus } from '../DevicesAndEquipmentsBlock/WorkOrderEnum';

import { getMyProductsAndServices } from '../SelfCareProductsAndServicesBlock/productsAndServicesBlockSlice';
export const getSelfCareData = createAsyncThunk('welcome/getSelfCareData', async (blockId, thunkAPI) => {
  try {
    const trackers = thunkAPI.dispatch(getTrackerItems());
    const benefits = thunkAPI.dispatch(getBenefit(blockId));
    const invoices = thunkAPI.dispatch(getMyInvoices());
    const selfCareData = await ProviderManager.getProviderData('selfCareData', {});
    thunkAPI.dispatch(getCustomerCoreProducts(selfCareData.Body.coreProducts));
    thunkAPI.dispatch(getMyProductsAndServices(selfCareData.Body.productsAndServicesDetails));
    //thunkAPI.dispatch(getMyProductsAndServices(selfCareData.Body.collaborationApproval));
    const results = [await trackers, await benefits, await invoices, selfCareData];
    selfCareData.Body.invoices = results[2].payload;
    selfCareData.Body.benefitResult = results[1].payload;
    return selfCareData;
  } catch (err) {
    thunkAPI.dispatch(getMyInvoices({ error: true }));
    return;
  }
});

export const openWorkOrder = createAsyncThunk('welcome/createWorkOrder', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    thunkAPI.dispatch(showAppLoader());
    const request = buildWorkOrderRequest(data, state);
    const result = await ProviderManager.getProviderData('createWorkOrder', request);
    const isSuccess = result.Body.isSuccess;

    const res = {
      isSuccess: isSuccess,
      data: data,
    };
    thunkAPI.dispatch(hideAppLoader());

    return res.isSuccess;
  } catch (error) {
    console.error('openWorkOrder - error : ', error);
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const clearCache = createAsyncThunk('welcome/clearCache', async (type, thunkAPI) => {
  try {
    ProviderManager.getProviderData('trackerClearCache', [type]);
  } catch (err) {
    return;
  }
});
export const debitAndRefund = createAsyncThunk('welcome/debitAndRefund', async (type, thunkAPI) => {
  try {
    const data = await ProviderManager.getProviderData('debitAndRefund', [type]);

    return data;
  } catch (err) {
    return;
  }
});

export const getOrganizationFamilyPackagesData = createAsyncThunk('saleBlock/getOrganizationFamilyPackagesData', async (data, thunkAPI) => {
  const result = await ProviderManager.getProviderData('getOrganizationFamilyPackagesData', []);
  return result?.Body;
});

function buildWorkOrderRequest(data, state) {
  let request = {};
  try {
    request = {
      banList: [],
      errorCode: 0,
      errorDescription: '',
      externalIdNum: '',
      firstName: state.authentication.loginData.userDetails.firstName,
      lastName: state.authentication.loginData.userDetails.lastName,
      identityNumber: state.authentication.loginData.userDetails.IDNumber,
      subscriber: state.authentication.loginData.userDetails.contactNumber,
      orderType: 'SELL_DEVICES_WORK_ORDER',
      psidList: [],
      movingApartment: null,
      saleJet: null,
      selfCareBusiness: {
        productType: data.productName,
        orgId: state.welcomeBlock.organizationId,
      },
      workOrderInfo: {
        workOrderCode: data.workOrderCode,
        workOrderTeam: data.workOrderTeam,
        productPrice: data.productPrice,
        productInfo: data.productInfo,
      },
    };
  } catch (error) {
    console.log('error => ', error);
  }

  return request;
}

export const getTrackerItems = createAsyncThunk('welcome/getTrackerItems', async (data, thunkAPI) => {
  let refundItems = [];
  let followUpRefundItem = [];
  let managerCallItems = [];
  let technicianVisitItems = [];
  let orderedTrackerItems = [];
  let abroadPackagesItems = [];
  let customerDeliveriesItems = [];
  let financeIssueItems = [];
  let numOfItems = 0;
  let error = false;
  let abroadInsuranceItems = [];

  try {
    const providerData = await ProviderManager.getProviderData('trackerData', {});
    const res = providerData?.Body;
    if (res.trackerItems.length > 0) {
      let baseItems = res.trackerItems;
      numOfItems = baseItems.length;
      baseItems.forEach((element) => {
        if (element._type === 'TechnicianVisit') {
          technicianVisitItems.push(element);
        } else if (element._type === 'FinanceIssue') {
          orderedTrackerItems.unshift(element);
        }
        // else if (element._type === 'AbroadInsurance') {
        //   abroadInsuranceItems.push(element);
        // }
        else {
          orderedTrackerItems.push(element);
        }
      });
    } else {
      error = true;
    }
  } catch (err) {
    console.log(err);
    error = true;
  }
  return {
    refundItems: refundItems,
    followUpRefundItem: followUpRefundItem,
    managerCallItems: managerCallItems,
    technicianVisitItems: technicianVisitItems,
    orderedTrackerItems: orderedTrackerItems,
    abroadPackagesItems: abroadPackagesItems,
    customerDeliveriesItems: customerDeliveriesItems,
    financeIssueItems: financeIssueItems,
    numOfItems: numOfItems,
    abroadInsuranceItems: abroadInsuranceItems,
    error: error,
  };
});

const welcomeSlice = createSlice({
  name: 'welcome',
  initialState: {
    trackerState: {
      refundItems: [],
      followUpRefundItem: [],
      managerCallItems: [],
      technicianVisitItems: [],
      orderedTrackerItems: [],
      abroadPackagesItems: [],
      customerDeliveriesItems: [],
      financeIssueItems: [],
      isShowTracker: false,
      numOfItems: 0,
      firstInView: 0,
      itemsToShow: 0,
      showPopUp: false,
      isLoading: true,
      error: false,
      actionLinks: {},
      popUpType: '',
      popUpProps: {},
      abroadInsuranceItems: [],
    },
    welcomeState: {
      firstName: '',
      lastName: '',
      workOrderState: '',
    },
    organizationState: {
      organizationCodeList: {},
      organizationName: '',
      organizationType: '',
      joinServiceLink: '',
      orgBannerDesktop: '',
      orgBannerMobile: '',
      desktopImageModeOne: '',
      mobileImageModeOne: '',
      adBannerDesktopImageModeTwo: '',
      adBannerMobileImageModeTwo: '',
      adBannerUrlModeTwo: '',
      trackerDesktopImageModeThree: '',
      trackerMobileImageModeThree: '',
      specialPackagesCellularList: {},
      organizationCoreProductData: {},
      organizationAdBannerDesktopImage: '',
      organizationAdBannerMobileImage: '',
      organizationAdBannerUrl: '',
      devicesToUpgradeList: {},
      hideFooterAndHeader: null,
    },
    paymentsState: {
      isLoading: true,
      products: [],
    },
    report: {
      invoices: '',
      coreProducts: '',
      collaborationApproval: '',
      benefitResult: '',
    },
    familyPackagesData: null,
    orgId: '',
  },
  customerType: {
    isPrivate: null,
    isBusiness: null,
  },

  reducers: {
    getClientName: (state, action) => {
      return {
        ...state,
      };
    },

    updateNumOfMsgs: (state, action) => {
      state.trackerState.firstInView = action.payload;
    },
    displayPopUp: (state, action) => {
      state.trackerState.showPopUp = action.payload;
    },
    setPopUpProps: (state, action) => {
      state.trackerState.popUpType = action.payload.popUpType;
      state.trackerState.popUpProps = action.payload.popUpProps;
    },
    setIsShowTracker: (state, action) => {
      state.trackerState.isShowTracker = action.payload;
    },
    setOrganizationDataAction: (state, action) => {
      state.organizationState = action.payload;
    },
    setCustomerType: (state, action) => {
      state.customerType = action.payload;
    },
    setOrgId: (state, action) => {
      state.orgId = action.payload;
    },
    setIsWorkOrderSucceeded: (state, action) => {
      state.welcomeState.workOrderState = action.payload;
    },
  },
  extraReducers: {
    [getSelfCareData.fulfilled]: (state, action) => {
      return {
        ...state,
        report: {
          products: action.payload?.Body?.coreProducts,
          invoices: action.payload?.Body?.invoices?.invoices,
          collaborationApproval: action.payload?.Body?.collaborationApproval,
          benefitResult: action.payload?.Body?.benefitResult,
        },
      };
    },
    [debitAndRefund.fulfilled]: (state, action) => {
      return { ...state, paymentsState: { products: action.payload?.Body, isLoading: false } };
    },
    [debitAndRefund.pending]: (state, action) => {
      return { ...state, paymentsState: { isLoading: true } };
    },
    [openWorkOrder.pending]: (state, action) => {
      return { ...state, state };
    },
    [openWorkOrder.fulfilled]: (state, action) => {
      let fulfilledRes = WorkOrderStatus.FAIL;
      if (action.payload) fulfilledRes = WorkOrderStatus.SUCCESS;

      return {
        ...state,
        welcomeState: { ...state.welcomeState, workOrderState: fulfilledRes },
      };
    },
    [getTrackerItems.fulfilled]: (state, action) => {
      return { ...state, trackerState: { isLoading: true } };
    },
    [getTrackerItems.fulfilled]: (state, action) => {
      const {
        refundItems,
        followUpRefundItem,
        managerCallItems,
        technicianVisitItems,
        abroadInsuranceItems,
        orderedTrackerItems,
        abroadPackagesItems,
        customerDeliveriesItems,
        financeIssueItems,
        numOfItems,
        error,
      } = action.payload;
      let isFinanceMessage = false;
      let isShowTracker = false;
      let getBanFinanceIssueType = orderedTrackerItems.find((x) => x._type == 'FinanceIssue');
      if (!getBanFinanceIssueType) {
        isShowTracker = true;
      } else {
        isShowTracker = true;
        isFinanceMessage = true;
      }
      let itemsToShow = 3;
      if (isMobile) {
        if (numOfItems === 1) {
          itemsToShow = 1.15;
        } else {
          itemsToShow = 1.35;
        }
      }
      if (error) {
        isShowTracker = false;
      }
      return {
        ...state,
        trackerState: {
          refundItems,
          followUpRefundItem,
          managerCallItems,
          abroadPackagesItems,
          customerDeliveriesItems,
          technicianVisitItems,
          abroadInsuranceItems,
          orderedTrackerItems,
          financeIssueItems,
          numOfItems,
          error,
          showPopUp: false,
          isLoading: false,
          firstInView: 0,
          itemsToShow: itemsToShow,
          isFinanceMessage: isFinanceMessage,
          isShowTracker: isShowTracker,
        },
      };
    },
    [getOrganizationFamilyPackagesData.fulfilled]: (state, action) => {
      state.familyPackagesData = action.payload;
    },
    [getOrganizationFamilyPackagesData.rejected]: (state, action) => {
      state.familyPackagesData = { isAllowed: false };
    },
  },
});
export const {
  getClientName,
  updateNumOfMsgs,
  displayPopUp,
  setPopUpProps,
  setIsShowTracker,
  setOrganizationDataAction,
  setCustomerType,
  setIsWorkOrderSucceeded,
  setOrgId,
} = welcomeSlice.actions;

export default welcomeSlice.reducer;
